import React, { type MouseEvent } from 'react';
import { TreeNodeLabel } from 'reactApp/ui/TreeComponent/TreeNodeLabel';
import { isFakedoorCompleted, markFakedoorCompleted } from 'reactApp/ui/VigboPrintFakedoor/utils';
import { renderVigboPrintModal } from 'reactApp/ui/VigboPrintFakedoor/VigboPrintModal/VigboPrintModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';

const sendRadar = createDwhTemplatedSender({ eventCategory: 'vigbo_badge', replacementSymbol: '_' });

export const VigboPrintAlbumBadge = () => {
    const onBadgeClick = (e: MouseEvent) => {
        // Отключаем переход в раздел альбомы
        e.preventDefault();
        e.stopPropagation();

        if (!isFakedoorCompleted()) {
            sendRadar({ action: 'fakedoor_click' });
            markFakedoorCompleted();
            renderVigboPrintModal();
        }
    };

    const onShow = () => {
        sendRadar({ action: 'fakedoor_show' });
    };

    return (
        <TreeNodeLabel onClick={onBadgeClick} onShow={onShow}>
            Распечатать
        </TreeNodeLabel>
    );
};
